import React, { Component } from "react";
import Popup from "../Popup/Popup";
import Strings from "@my-dld/assets/strings";
import { MSChargeBreakdown, MSChargesBreakdown } from "@eres/mollakservicechargeapi/entities";
import { JQModal } from "../Popup/Utils";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { toFormattedCurrency } from "@eres/core/dist/Currency";
import Switch from "../Switch";
import { ImperialSystem, MetricSystem, UnitSystem } from "@my-dld/utils/UnitUtils";
import { dispatch } from "@my-dld/utils/StoreUtils";
import Actions from "@my-dld/actions";
import { getAppServices } from "@10x/coreapp";

interface Props {
	chargesBreakDown: MSChargesBreakdown;
	onDismiss: () => void;
}

interface State {
	unit: UnitSystem;
}

class BreakdownPopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			unit: getAppServices().storeService.getStore().getState().User.unit,
		};
	}

	render() {
		const { chargesBreakDown, onDismiss } = this.props;
		const generalFunds = chargesBreakDown.generalFund;
		const reserveFunds = chargesBreakDown.reserveFund;
		const additionalCharges = chargesBreakDown.additionalCharges;
		const { unit } = this.state;
		return <Popup
			id={ "BreakdownPopup" }
			autoOpenMount={ true }
			showIcon={ false }
			noTitle={ true }
			showCloseButton={ false }
			modalSubContainer="modal-dialog modal-dialog-centered"
			modalBodyContainer={ "" }
			header={ <div className="modal-header">
				<h5 className="modal-title">{ Strings.service_charges_info }</h5>
				<button
					type="button" className="close modal-close-svg-icon" data-bs-dismiss="modal"
					aria-label="Close">
					<span className="close-svg-icon"/>
					<span className="sr-only">{ Strings.close }</span>
				</button>
			</div> }
			onDismiss={ () => {
				JQModal( "BreakdownPopup" ).hide();
				onDismiss();
			} }>
			<div className="modal-body">
				<div className="d-flex justify-content-end mb-2">
					<Switch
						id={ "breakdown_unit" }
						onLabel={ Strings.sq_mt }
						offLabel={ Strings.sq_ft }
						value={ this.state.unit.Id === MetricSystem.Id }
						onChange={ ( isSqm ) => {
							const update = { unit: ImperialSystem };
							if ( isSqm )
								update.unit = MetricSystem;
							this.setState( update, () => {
								dispatch( Actions.UNIT_CHANGED, this.state.unit );
							} );
						} }
					/>
				</div>
				<ul className="list-group mydld-service-charge">
					{ generalFunds && generalFunds.length > 0 &&
						<RenderBreakdown title={ Strings.general_fund } unit={ unit } funds={ generalFunds }/> }
					{ reserveFunds && reserveFunds.length > 0 &&
						<RenderBreakdown title={ Strings.reserve_fund } unit={ unit } funds={ reserveFunds }/> }
					{ additionalCharges && additionalCharges.length > 0 &&
						<RenderBreakdown title={ Strings.additional_charges } unit={ unit } funds={ additionalCharges }/> }
				</ul>
			</div>
			<div className="modal-footer justify-content-center p-2">
				<button
					type="button" className="btn btn-grey" onClick={ () => {
					JQModal( "BreakdownPopup" ).hide();
					onDismiss();
				} }>{ Strings.close }</button>
			</div>
		</Popup>;
	}
}

function RenderBreakdown( props: { title: string, unit: UnitSystem, funds: MSChargeBreakdown[] } ) {
	const { title, unit, funds } = props;
	const isSqFt = ( unit.Id === ImperialSystem.Id );
	let total = 0;
	return <React.Fragment>
		<li className="list-group-item mydld-service-charge-title">
			<span>{ title }</span>
			<span>{ isSqFt ? Strings.rate_sq_ft : Strings.rate_sq_mt }</span>
		</li>
		{ funds.map( ( breakdown: MSChargeBreakdown ) => {
			const isNotTotal = ( breakdown.nameEn.trim().toLocaleLowerCase() !== "total" );
			const amount = isSqFt ? Number( breakdown.amountSqft ) : Number( breakdown.amountSqM );
			total += isNotTotal ? amount : 0;
			return isNotTotal ? <li key={ `${ title }_${ breakdown.nameEn }` } className="list-group-item">
				<span>{ getLocalValue( breakdown ) }</span>
				<span>{ toFormattedCurrency( amount ) + " " + Strings.aed }</span>
			</li> : null;
		} ) }
		<li key={ `${ title }_${ total }` } className="list-group-item">
			<span><b>{ Strings.total }</b></span>
			<span><b>{ toFormattedCurrency( total ) + " " + Strings.aed }</b></span>
		</li>
	</React.Fragment>;
}

export default BreakdownPopup;
